const _btn = $('.js-accordion-trigger');
_btn.on('click', function () {
    let _e = $(this);
    _e.toggleClass('-open');
		if ($(window).width() >= 1024) {
			_e.next('.js-accordion-target').slideToggle(500, 'swing');
		} else {
				_e.next('.js-accordion-target').slideToggle(250, 'swing');
		}
});

const _closeBtn = $('.js-accordion-closeTrigger');
_closeBtn.on('click', function () {
    let _e = $(this);
    _e.closest('.js-accordion-target').slideToggle(250, 'swing');
    _e.parent().siblings('.js-accordion-trigger').removeClass('-open');
});

$(document).on('click', '.js-accordion-closeTrigger', function(e) {
	e.preventDefault();
	var $trigger = $(this).parents().siblings('.js-accordion-trigger');
	$('html, body').animate({
			scrollTop: $trigger.offset().top - 100
	});
});
